import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface TrustBadgesProps {
  variant?: 'light' | 'dark';
  className?: string;
}
export function TrustBadges({
  variant = 'light',
  className = ''
}: TrustBadgesProps) {
  const text = variant === 'light' ? 'text-brand-slate' : 'text-white';
  const shield = variant === 'light' ? 'text-brand-pink' : 'text-brand-gold';
  return <div className={`flex flex-col sm:flex-row justify-center items-center gap-0.5 sm:gap-4 text-[11px] sm:text-xs font-bold ${text} ${className}`} data-id="element-149" data-mp="3cg70weywyuby">
      <span data-id="element-150" data-mp="37gkm413ft611">⭐⭐⭐⭐⭐ 4.9/5 — Recensioni Verificate dagli Allenatori</span>
      <span className="flex items-center gap-1 text-center" data-id="element-151" data-mp="3l7foqvnceqw6">
        <ShieldCheckIcon className={`w-3.5 h-3.5 shrink-0 ${shield}`} data-id="element-152" data-mp="3h6vr7qyuxl9i" />
        🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni — Zero Rischi
      </span>
    </div>;
}